import styled from "styled-components";
import { ModalButtonYellow } from "common/modal/MoreModalButtons";

export const ModalContent = styled.div`
  max-height: 350px;
  overflow-y: auto;
  margin-bottom: 16px;
  padding: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background-color: #fafafa;
  position: relative;
`;

export const ScrollIndicator = styled.div`
  position: sticky;
  top: 0;
  background: linear-gradient(
    to bottom,
    #fafafa 0%,
    rgba(250, 250, 250, 0.9) 70%,
    transparent 100%
  );
  text-align: center;
  padding: 6px;
  margin: -12px -12px 6px -12px;
  font-size: 13px;
  color: #1070b6;
  font-weight: 500;
  z-index: 1;
`;

export const TermsText = styled.div`
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  padding: 0;
  color: #262626;

  h2 {
    font-size: 16px;
    font-weight: bold;
    margin: 4px 0 2px 0;
    padding: 8px 0;
  }

  h3 {
    font-size: 14px;
    font-weight: 600;
    margin: 3px 0 1px 0;
    padding: 2px 0;
  }

  p {
    margin: 2px 0;
    padding: 2px 0;
  }

  li {
    margin: 1px 0;
    padding: 2px 0;
  }

  ul,
  ol {
    margin: 2px 0;
    padding: 2px 0 1px 16px;
  }

  strong {
    font-weight: 600;
  }

  a {
    color: #1070b6;
    text-decoration: underline;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const StyledModalButton = styled(ModalButtonYellow)`
  &.disabled-grey {
    .ant-btn {
      background-color: #d9d9d9 !important;
      border-color: #d9d9d9 !important;
      color: #8c8c8c !important;
      cursor: not-allowed !important;

      &:hover,
      &:focus,
      &:active {
        background-color: #d9d9d9 !important;
        border-color: #d9d9d9 !important;
        color: #8c8c8c !important;
      }
    }
  }
`;
